<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper hero" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal champion">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div>
							<div class="contentHeader unselectable">
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>Галерея Чемпионов</span></span>
								</h2>
								<div class="championDescription"><span>Вы можете прикреплять чемпионов к деревням и городам, чтобы получать сильные бонусные эффекты. Прокачивайте их, чтобы эффекты стали ещё мощнее!</span></div>
							</div>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
			<div tabulation="" class="contentTabulation"><!-- ngIf: tabData.tabs.length > 1 -->
<div class="tabulationContent scrollable tabContent" ng-class="'tabContent' + tabData.currentTab" scrolling-disabled="false" dynamic="" scrollable=""><div class="scrollContentOuterWrapper active" style="width: 610px;">
	<div class="scrollContent" dynamic-height="true" style="width: 630px; overflow-y: auto; max-height: 158px;">
		<div class="scrollContentInnerWrapper" ng-transclude="" style="width: 610px;">
	<div ng-transclude="">
				<div id="champion" ng-controller="championCtrl">
	<div class="championGallery" open-overlay="openOverlay" on-assign="assignChampion(champion)">
	<div class="championSelection" champions="champions" selected-champion="selectedChampion">
	<!-- ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) --><div ng-if="champions.length &gt; 1 &amp;&amp; (!disableMaxed || !allMaxed)" class="greenArrow arrowDirectionFrom clickable" ng-class="{disabled: !(selectedChampion &gt;= 0)}" clickable="selectNextChampion(true)"></div><!-- end ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) -->
	<div scrollable="" horizontal="" scroll-duration="300" class="scrollable" style="overflow-y: hidden;"><div class="scrollContentOuterWrapper active" style="height: 92px;">
	<div class="scrollContent" dynamic-height="false" style="height: 107px; overflow-x: auto;">
		<div class="scrollContentInnerWrapper" ng-transclude="" style="white-space: nowrap; height: 92px;">
		<!-- ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable active" clickable="changeChampion(index)">
			<div class="championProfileImage caesar rarity0">
				<!-- ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage cleopatra rarity0">
				<!-- ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage vercingetorix rarity0">
				<!-- ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage edithe rarity1">
				<!-- ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage incitatus rarity2">
				<!-- ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage arleno rarity2">
				<!-- ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage galen rarity2">
				<!-- ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions --><a ng-repeat="(index, champion) in champions" ng-class="{active: selectedChampion == index, disabled: disableMaxed &amp;&amp; champion.data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" class="championButton clickableContainer clickable" clickable="changeChampion(index)">
			<div class="championProfileImage teutobod rarity3">
				<!-- ngIf: ::showProficiency -->
			</div>

		</a><!-- end ngRepeat: (index, champion) in champions -->
	</div>
	</div>
</div>
<div class="scrollTrack horizontal" style="opacity: 1; display: block;">
    <div class="scrollHandle" style="left: 0px; width: 531.571px;"></div>
	<div class="trackDecoration"></div>
</div></div>
	<!-- ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) --><div ng-if="champions.length &gt; 1 &amp;&amp; (!disableMaxed || !allMaxed)" class="greenArrow arrowDirectionTo clickable" ng-class="{disabled: !(selectedChampion &gt;= 0)}" clickable="selectNextChampion()"></div><!-- end ngIf: champions.length > 1 && (!disableMaxed || !allMaxed) -->
</div>

	<div class="championDetails contentBox section">
		<div class="contentBoxHeader headerWithArrowEndings">
			<div class="content" options="caesar" translate=""><span>Цезарь</span></div>
		</div>
		<div class="contentBoxBody">
			<div class="symbol_i_medium_wrapper clickable" clickable="openWindow('help', {'pageId': 'Village_Champions'})"><i class="symbol_i_tiny_flat_white"></i></div>
			<div class="imageBox">
				<div class="championImage caesar"></div>
				<div class="championPodium champion_podium_layout"></div>
			</div>

			<div class="descriptionBox">
				<div class="championDescription" options="caesar" translate=""><span>"Этот мудрый тактик организует ваши войска и ускорит подготовку вашей пехоты."</span></div>
				<div class="patronLevel">
					<span translate=""><span>В этом игровом мире у вас будет доступ ко всем существующим чемпионам. При запуске проекта большинство чемпионов будут требовать разблокировки.</span></span>
				</div>
				<div class="championEffects">
					<div class="currentEffect" options="caesar" data="bonus: -20" translate=""><span>&#x202D;-&#x202D;20&#x202C;%&#x202C; время обучения пехоты </span></div>
					<div class="effectTier active" ng-class="{active: 0 == champions[selectedChampion].data.level}">
						<i class="champion_proficiency0_medium_flat_black"></i>
						<span data="bonus: -20" translate=""><span>База: &#x202D;-&#x202D;20&#x202C;%&#x202C;</span></span>
					</div>
					<!-- ngRepeat: n in [] | range:1:3 --><div class="effectTier" ng-class="{active: n == champions[selectedChampion].data.level}" ng-repeat="n in [] | range:1:3">
						<i class="champion_proficiency1_medium_flat_black"></i>
						<span data="level: 1, bonus: -30" translate=""><span>Навык 1: &#x202D;-&#x202D;30&#x202C;%&#x202C;</span></span>
					</div><!-- end ngRepeat: n in [] | range:1:3 --><div class="effectTier" ng-class="{active: n == champions[selectedChampion].data.level}" ng-repeat="n in [] | range:1:3">
						<i class="champion_proficiency2_medium_flat_black"></i>
						<span data="level: 2, bonus: -40" translate=""><span>Навык 2: &#x202D;-&#x202D;40&#x202C;%&#x202C;</span></span>
					</div><!-- end ngRepeat: n in [] | range:1:3 --><div class="effectTier" ng-class="{active: n == champions[selectedChampion].data.level}" ng-repeat="n in [] | range:1:3">
						<i class="champion_proficiency3_medium_flat_black"></i>
						<span data="level: 3, bonus: -50" translate=""><span>Навык 3: &#x202D;-&#x202D;50&#x202C;%&#x202C;</span></span>
					</div><!-- end ngRepeat: n in [] | range:1:3 -->
				</div>
				<div class="championButtons">
					<button clickable="openOverlay('upgradeChampion', {'champion': 0 })" ng-class="{disabled: !player.finishedTutorial() || champions[selectedChampion].data.level &gt;= $root.config.balancing.championConfig.upgrades.length}" tooltip="" tooltip-translate-switch="{
								'Tutorial.Tooltip.ButtonDisabled': false
							}" class="clickable" @click="gameModel.champions.upgradeChampionShow = true"><div class="content">
	<span ng-transclude="" class="innerText">
						<span translate=""><span>Улучшить</span></span>
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button>
					<!-- ngIf: champions[selectedChampion].data.villageId == 0 --><button ng-if="champions[selectedChampion].data.villageId == 0" clickable="!(slotLimitInfo.villageLimitReached || slotLimitInfo.totalLimitReached) ? assignChampion(champions[selectedChampion]) : goToVillage(0, true)" ng-class="{disabled: !mainBuilding || isWWVillage || !player.finishedTutorial()}" tooltip="" tooltip-translate-switch="{
								'Tutorial.Tooltip.ButtonDisabled': false,
								'Champion.Button.Assign.Disabled.Tooltip.MainBuilding': false,
								'MainBuilding.Champions.ChampionSlot.WWVillage': false
							}" class="clickable"><div class="content">
	<span ng-transclude="" class="innerText">
						<span translate=""><span>Выдать права</span></span>
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button><!-- end ngIf: champions[selectedChampion].data.villageId == 0 -->
					<!-- ngIf: champions[selectedChampion].data.villageId != 0 -->
					 <button ng-if="champions[selectedChampion].data.villageId != 0" clickable="goToVillage(champions[selectedChampion].data.villageId)" class="clickable"><div class="content">
	<span ng-transclude="" class="innerText">
						<span translate=""><span>Отправиться в деревню</span></span>
					</span>
	<!-- ngIf: price > 0 || forceGoldUsage -->
	<!-- ngIf: price == -1 && !forceGoldUsage -->

	<div class="animationOverlay"></div>
	<i class="checkmark action_check_small_flat_white"></i>
	<i class="checkmark action_check_small_flat_black"></i>
	<i class="checkmark action_check_small_flat_red"></i>
</div></button>
				</div>
			</div>
		</div>
	</div>
</div>
</div>
			</div>
</div>
	</div>
</div>
</div></div>
		</div>
						<div class="window-overlay">
							
							<upgrade-champion v-if="gameModel.champions.upgradeChampionShow" />
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import UpgradeChampion from '@/components/pages/champions/windowOverlay/UpgradeChampion';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Галерея Чемпионов | IW'});
	},
	data: () => ({
		champions: [
			{
				name: 'Цезарь',
				quote: 'Этот мудрый тактик организует ваши войска и ускорит подготовку вашей пехоты.',
				description: 'В этом игровом мире у вас будет доступ ко всем существующим чемпионам. При запуске проекта большинство чемпионов будут требовать разблокировки.',
				skillName: 'время обучения пехоты',
				skillLevel: 0,
				levelValues: [
					'-20%',
					'-30%',
					'-40%',
					'-50%',
				],
			},
			{
				name: 'Клеопатра',
				quote: 'Эта королева родом из далекой страны. Она оставила свой народ, чтобы поддержать вас в стремлении к власти и поможет прокормить вашу армию.',
				description: 'В этом игровом мире у вас будет доступ ко всем существующим чемпионам. При запуске проекта большинство чемпионов будут требовать разблокировки.',
				skillName: 'производство зерна',
				skillLevel: 0,
				levelValues: [
					'-20%',
					'-30%',
					'-40%',
					'-50%',
				],
			},
			{
				name: 'Верцингеторикс',
				quote: 'Благодаря своим уникальным знаниям местности этот лидер поможет сохранить жизнь вашим войскам.',
				description: 'В этом игровом мире у вас будет доступ ко всем существующим чемпионам. При запуске проекта большинство чемпионов будут требовать разблокировки.',
				skillName: 'уклонение от войск',
				skillLevel: 0,
				levelValues: [
					'-25%',
					'-50%',
					'-75%',
					'-100%',
				],
			},
			{
				name: 'Эдит',
				quote: 'Этот квартирмейстер твердой рукой управляет поставками, что позволит вам содержать многочисленные армии.',
				description: 'В этом игровом мире у вас будет доступ ко всем существующим чемпионам. При запуске проекта большинство чемпионов будут требовать разблокировки.',
				skillName: 'потребление зерна',
				skillLevel: 0,
				levelValues: [
					'-10%',
					'-20%',
					'-30%',
					'-40%',
				],
			},
			{
				name: 'Инцитат',
				quote: 'Этот жеребец не только безмерно почитаем, но и является отличным образцом для обучения вашей кавалерии.',
				description: 'В этом игровом мире у вас будет доступ ко всем существующим чемпионам. При запуске проекта большинство чемпионов будут требовать разблокировки.',
				skillName: 'время обучения кавалерии',
				skillLevel: 0,
				levelValues: [
					'-20%',
					'-30%',
					'-40%',
					'-50%',
				],
			},
			{
				name: 'Арлено',
				quote: 'Благодаря своей связи с природой, этот фуражир поможет вам обеспечить кавалерию провизией, чтобы вы могли содержать более крупные армии.',
				description: 'В этом игровом мире у вас будет доступ ко всем существующим чемпионам. При запуске проекта большинство чемпионов будут требовать разблокировки.',
				skillName: 'потребление зерна кавалерией',
				skillLevel: 0,
				levelValues: [
					'-10%',
					'-20%',
					'-30%',
					'-40%',
				],
			},
			{
				name: 'Гален',
				quote: 'Благодаря своим познаниям в области человеческого тела, этот учёный и медик поможет вам ускорить исцеление ваших войск.',
				description: 'В этом игровом мире у вас будет доступ ко всем существующим чемпионам. При запуске проекта большинство чемпионов будут требовать разблокировки.',
				skillName: 'время лечения',
				skillLevel: 0,
				levelValues: [
					'-20%',
					'-30%',
					'-40%',
					'-50%',
				],
			},
			{
				name: 'Тевтобод',
				quote: 'Этот боец передаст свою исполинскую силу (и программу тренировок) вашим осадным войскам, что сократит расходы на их содержание.',
				description: 'В этом игровом мире у вас будет доступ ко всем существующим чемпионам. При запуске проекта большинство чемпионов будут требовать разблокировки.',
				skillName: 'потребление зерна осадными войсками',
				skillLevel: 0,
				levelValues: [
					'-10%',
					'-20%',
					'-30%',
					'-40%',
				],
			},
		],
		
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		tab: 'inventory',
		
		villageBackgroundLeft: '0px',
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		onToggleTab(tab, push = true){
			this.tab = tab;
			if(push) this.$router.push({query: {tab}});
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		if(this.$route.query.tab) this.tab = this.$route.query.tab;
		else this.$router.push({query: {tab: this.tab}});
	},
	unmounted(){
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next){
		if(!to.query.tab) this.$router.push({query: {tab: 'inventory'}});
		else if(to.query.tab != this.tab) this.onToggleTab(to.query.tab, false);
		next();
	},
	created(){
		this.gameModel.buildingQueueShow = true;
	},
	components: {
		UpgradeChampion,
	},
}
</script>
